import { GetCustomerAccountsRequestDto } from "../dtos/get-customer-accounts-request.dto";
import { GetSalesMarketplaceItemsRequestDto } from "../dtos/get-sales-marketplace-items-request.dto";
import { GetSalesMarketplaceItemsResponseDto, MarketPlaceItemDto } from "../dtos/get-sales-marketplace-items-response.dto";
import { GetSalesOrdersRequestDto } from "../dtos/get-sales-orders-request.dto";
import { GetShoppingCartsRequestDto } from "../dtos/get-shopping-carts-request.dto";
import { ResolveAccountShippingServicesRequestDto } from "../dtos/resolve-account-shipping-services-request.dto";
import { OrdersResult } from "../models/order.model";
import { ShopItem, ShopItemsResult } from "../models/shop-item.model";


export function mapToGetSalesOrdersRequestDto(params: any): GetSalesOrdersRequestDto {
  return {
    id: params.ids ?? [],
    number: params.number ?? null,
    accountId: params.accountId,
    shippingDateFrom: params.shippingDateFrom,
    shippingDateTo: params.shippingDateTo,
    includeItems: params.includeItems ?? false,
    includeShippingOriginAddress: params.includeShippingOriginAddress ?? false,
    includeShippingDestinationAddress: params.includeShippingDestinationAddress ?? false,
    orderBy: params.orderBy ?? null,
    paging: {
      pageNumber: params.paging?.pageNumber ?? 1,
      rows: params.paging?.rows ?? 50
    }
  };
}

export function mapToGetShoppingCartsRequestDto(params: any): GetShoppingCartsRequestDto {
  return {
    userId: params.userId ?? null,
    shoppingCartIds: params.ids ?? params.shoppingCartIds ?? [],
    paging: {
      pageNumber: params.paging?.pageNumber ?? 1,
      rows: params.paging?.rows ?? 50
    }
  };
}

export function mapToGetSalesMarketplaceItemsRequestDto(params: any): GetSalesMarketplaceItemsRequestDto {
  return {
    ids: params.id ? [params.id] : [],
    searchText: params.searchText ?? null,
    inventoryListingIds: params.listings ?? [],
    accountId: params.customerAccount,
    shippingDate: params.shippingDate ?? new Date().toISOString(),
    inventoryStatus: params.inventoryStatus ?? null,
    productCategoryPath: params.productCategories ?? [],
    packed: params.productPacked ?? null,
    paging: {
      pageNumber: params.paging?.pageNumber ?? 1,
      rows: params.paging?.rows ?? 50
    }
  };
}

export function mapToShopItemsResult(
  res: GetSalesMarketplaceItemsResponseDto
): ShopItemsResult {
  const data = (res as any).data ?? res;
  return {
    items: (data.marketPlaceItems ?? []).map((o: any) => mapToShopItem(o)),
    totalItems: data.totalItems,
    pageNumber: data.pageNumber,
    itemsPerPage: data.itemsPerPage,
    totalPages: data.totalPages
  };
}

export function mapToShopItem(o: MarketPlaceItemDto): ShopItem {
  return {
    id: o.id,
    productId: o.product.id,
    productName: o.product.name,
    productReference: o.product.reference,
    productCategoryPath: o.product.category?.path,
    fullPackage: o.product.package?.name ?? undefined,
    pack: o.pack,
    innerPack: o.innerPack,
    status: o.status,
    quantity: o.quantity,
    quantityUnit: o.quantityUnit,
    unitPrice: o.unitPrice,
    listingPrice: o.listingPrice ?? o.unitPrice,
    priceUnit: o.priceUnit,
    quantityToAdd: null,

    imageUrl: o.product.imageUrl,
    _invalidImage: true
  };
}

export function mapToResolveAccountShippingServicesRequestDto(params: any): ResolveAccountShippingServicesRequestDto {
  return {
    accountId: params.accountId,
    inputDate: params.inputDate,
    date: params.date
  };
}

export function mapToGetCustomerAccountsRequestDto(params: any): GetCustomerAccountsRequestDto {
  return {
    id: params.id ?? null,
    includeShippingLocations: params.includeShippingLocations ?? false,
    isActive: params.isActive ?? true,
    orderBy: params.orderBy ?? null,
    paging: {
      pageNumber: params.paging?.pageNumber ?? 1,
      rows: params.paging?.rows ?? 50
    }
  };
}

export function mapToOrdersResult(
  res: any
): OrdersResult {
  return {
    orders: res.salesOrders ?? [],
    totalItems: res.totalItems,
    pageNumber: res.pageNumber,
    itemsPerPage: res.itemsPerPage,
    totalPages: res.totalPages
  };
}